var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "courseScheduleOrderModal",
      staticClass: "modal fade course-schedules-details",
      attrs: { tabindex: "-1", "aria-hidden": "true" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _vm.courseSchedule
              ? _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(
                    "\n                    #" +
                      _vm._s(_vm.courseSchedule.id) +
                      " " +
                      _vm._s(_vm.courseSchedule.course.name) +
                      "\n                "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn-close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.hide()
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.courseSchedule
            ? _c("div", { staticClass: "modal-body" }, [
                _c(
                  "div",
                  { staticClass: "row guest-list my-2" },
                  _vm._l(_vm.guests, function (guest) {
                    return _c("div", { staticClass: "col-sm" }, [
                      _vm.isOrderedByGuest(guest)
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-success",
                              attrs: { title: "cancel the order" },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelCourseOrder(guest)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            #" +
                                  _vm._s(guest.user.id) +
                                  " " +
                                  _vm._s(guest.user.name) +
                                  "\n                            [" +
                                  _vm._s(guest.path) +
                                  "] "
                              ),
                              guest.room
                                ? _c("span", [
                                    _vm._v(
                                      "Room " + _vm._s(guest.room.number) + "]"
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-outline-secondary",
                              attrs: {
                                title: "make new order",
                                disabled: !_vm.isGuestAvailable(guest),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.order(guest)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            #" +
                                  _vm._s(guest.user.id) +
                                  " " +
                                  _vm._s(guest.user.name) +
                                  "\n                            [" +
                                  _vm._s(guest.path) +
                                  "] "
                              ),
                              guest.room
                                ? _c("span", [
                                    _vm._v(
                                      "Room " + _vm._s(guest.room.number) + "]"
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Path"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.courseSchedule.path.name) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Status"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm.courseSchedule.is_active
                      ? _c("span", { staticClass: "text-success" }, [
                          _vm._v("active"),
                        ])
                      : _c("span", { staticClass: "text-danger" }, [
                          _vm._v("not active"),
                        ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Date"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.dateFormat(_vm.courseSchedule.from, "dddd, D MMM")
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Time"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm._v(
                      "\n                        from " +
                        _vm._s(
                          _vm.dateFormat(_vm.courseSchedule.from, "h:mm a")
                        ) +
                        " till\n                        " +
                        _vm._s(
                          _vm.dateFormat(_vm.courseSchedule.till, "h:mm a")
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Class"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href: _vm.courseSchedule.course.link,
                        },
                      },
                      [_vm._v(_vm._s(_vm.courseSchedule.course.name))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Trainer"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm.courseSchedule.trainer
                      ? _c("span", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.courseSchedule.trainer.link,
                              },
                            },
                            [_vm._v(_vm._s(_vm.courseSchedule.trainer.name))]
                          ),
                        ])
                      : _c("span", [_vm._v("no")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Level"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.courseSchedule.level.name) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Capacity"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.courseSchedule.capacity -
                            _vm.courseSchedule.guest_ids.length
                        ) +
                        " / " +
                        _vm._s(_vm.courseSchedule.capacity) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4 label" }, [
                    _vm._v("Location"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm.courseSchedule.location
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.courseSchedule.location.link,
                              },
                            },
                            [_vm._v(_vm._s(_vm.courseSchedule.location.name))]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.courseSchedule.location_comment
                      ? _c("span", [
                          _c("em", [
                            _vm._v(_vm._s(_vm.courseSchedule.location_comment)),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _vm.courseSchedule
              ? _c("div", { staticStyle: { "margin-right": "auto" } }, [
                  _vm.courseSchedule.url
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-info",
                          attrs: {
                            href: _vm.courseSchedule.url,
                            target: "_blank",
                          },
                        },
                        [_vm._v("Open\n                        in new tab")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.refresh()
                        },
                      },
                    },
                    [_vm._v("Refresh")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.hide()
                  },
                },
              },
              [_vm._v("Close")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }